/*
 * @Author: liyue liyue@gennlife.com
 * @Date: 2025-03-27 09:32:19
 * @LastEditors: liyue liyue@gennlife.com
 * @LastEditTime: 2025-03-27 11:01:44
 * @FilePath: /兰州众科/lanzhouzhongke_pc/src/utils/request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { getToken, removeToken } from './auth'
import store from '@/store'

const service = axios.create({
  // 使用环境变量中的API基础URL
  baseURL: process.env.VUE_APP_API_BASE_URL
  // 之前的硬编码地址已迁移到环境变量：
  // baseURL: 'http://82.156.138.13:9301/'
  // baseURL: 'http://39.102.203.127:9301/'
  // http://192.168.0.55:9301/
})

// 是否显示重新登录
export let isRelogin = { show: false };

service.interceptors.request.use((req) => {
  const token = getToken()
  req.headers.Authorization = req.isNoToken ? '' : (token ? ` ${token}` : '')
  if (req?.responseType) req.headers.responseType = req.responseType
  return req
}, (err) => Promise.reject(err))

service.interceptors.response.use((res) => {
  const { code, msg } = res.data || {}
  if (code === 401) {
    if (!isRelogin.show) {
      isRelogin.show = true;
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).then(() => {
        isRelogin.show = false;
        store.dispatch('LogOut').then(() => {
          location.href = '/';
        })
      }).catch(() => {
        isRelogin.show = false;
      });
    }
    return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
  } else if (code === 200) {
    return res.data
  } else {
    console.log(res.data, "--->res.data");
    // 关键：判断 res.data 是否为 Blob 文件类型，是则直接返回不弹提示
    if (res.data instanceof Blob) {
      return res.data;
    }
    // 显示错误消息
    Message({
      message: msg || '请求失败',
      type: 'error',
      duration: 2 * 1000
    })
    // console.log(res.data, "--->res");
    return res.data
    // // 返回Promise.reject以确保错误能被catch捕获
    // return Promise.reject(new Error(msg || '请求失败'))
  }

}, (err) => {
  console.error('请求错误:', err)

  // 处理HTTP状态码错误
  const status = err.response?.status
  const { msg, code } = err.response?.data || {}

  let errorMessage = msg || '网络错误，请稍后重试'

  // 根据HTTP状态码设置错误消息
  switch (status) {
    case 401:
      removeToken()
      window.location.href = '/#/login'
      return Promise.reject(new Error('登录已过期'))
    case 403:
      errorMessage = '没有权限访问该资源'
      break
    case 404:
      errorMessage = '请求的资源不存在'
      break
    case 500:
      errorMessage = msg || '服务器内部错误，请联系管理员'
      break
    case 502:
      errorMessage = '网关错误'
      break
    case 503:
      errorMessage = '服务暂不可用'
      break
    default:
      if (!status) {
        errorMessage = '网络连接失败，请检查网络设置'
      }
  }

  // 显示错误消息
  Message({
    message: errorMessage,
    type: 'error',
    duration: 3 * 1000
  })
  return err

})

export default service
